/**
 * New / Improved / Fixed tag pill — OMN-368.
 * Same idiom as ui/priority-chip.tsx (rounded-full border chip + color map).
 */
import React from 'react';
import { ChangelogTag as Tag } from './whatsNewData';
import { useLanguage } from '../../contexts/LanguageContext';

const COLORS: Record<Tag, string> = {
  new: 'bg-green-100 text-green-800 border-green-200',
  improved: 'bg-blue-100 text-blue-800 border-blue-200',
  fixed: 'bg-gray-100 text-gray-700 border-gray-200',
};

export const ChangelogTag: React.FC<{ tag: Tag }> = ({ tag }) => {
  const { t } = useLanguage();
  return (
    <span
      className={`inline-flex items-center rounded-full border font-medium text-xs px-2 py-0.5 ${COLORS[tag]}`}
      role="status"
    >
      {t(`whatsNew.tags.${tag}`)}
    </span>
  );
};
